import { Glue42 } from "../../glue";
import { ThemesImpl } from "./themes";
import { Glue42Core } from "@glue42/core";

export function factory(core: Glue42Core.GlueCore): Glue42.Themes.API & { ready: () => Promise<void>; } {
    const themes = new ThemesImpl(core);

    return {
        list: themes.list.bind(themes),
        getCurrent: themes.getCurrent.bind(themes),
        select: themes.select.bind(themes),
        onChanged: themes.onChanged.bind(themes),
        ready: () => Promise.resolve(),
    };
}
